import { typography } from '@/shared/theme/tokens';
import { TERM } from '../liveModeMeta';

const MONO = typography.fontFamily.mono;

/**
 * One terminal pane: borderless surface that fills its grid cell. The screen's
 * 1px grid gap draws the hairline rules between panes, so panes carry no border
 * of their own — keeping the whole screen reading as a single instrument.
 */
export function Pane({ children, style }) {
  return (
    <div style={{
      flex: 1, minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column',
      background: TERM.panel, overflow: 'hidden', ...style,
    }}>
      {children}
    </div>
  );
}

/**
 * Consistent pane title bar: a leading accent tick, the title in tracked mono
 * caps, optional status accent, and a bracketed count on the right.
 */
export function PaneHeader({ title, count, accent = TERM.accent, right }) {
  return (
    <div style={{
      flexShrink: 0, display: 'flex', alignItems: 'center', gap: 9, height: 28, padding: '0 12px',
      background: TERM.raised, borderBottom: `1px solid ${TERM.line}`,
    }}>
      <span style={{ width: 3, height: 12, background: accent, flexShrink: 0 }} />
      <span style={{
        fontFamily: MONO, fontSize: typography.fontSize.xs, fontWeight: typography.fontWeight.bold,
        letterSpacing: typography.letterSpacing.widest, textTransform: 'uppercase', color: TERM.inkDim,
      }}>
        {title}
      </span>
      {count != null && (
        <span style={{
          fontFamily: MONO, fontSize: typography.fontSize.xs, color: TERM.inkFaint,
          fontVariantNumeric: 'tabular-nums',
        }}>
          [{count}]
        </span>
      )}
      {right && <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8 }}>{right}</span>}
    </div>
  );
}
